import { render, staticRenderFns } from "./closeModalBtn.vue?vue&type=template&id=b98064ec&scoped=true&"
import script from "./closeModalBtn.vue?vue&type=script&lang=js&"
export * from "./closeModalBtn.vue?vue&type=script&lang=js&"
import style0 from "./closeModalBtn.vue?vue&type=style&index=0&id=b98064ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98064ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b98064ec')) {
      api.createRecord('b98064ec', component.options)
    } else {
      api.reload('b98064ec', component.options)
    }
    module.hot.accept("./closeModalBtn.vue?vue&type=template&id=b98064ec&scoped=true&", function () {
      api.rerender('b98064ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loginPublic/closeModalBtn.vue"
export default component.exports